const opt = (values) => values.map((v) => ({ value: v, label: v }));

export const STATE_OPTIONS = opt(['LIVE', 'PAUSED', 'MUTED', 'DISABLED', 'ARCHIVED']);
export const CHANNEL_OPTIONS = opt(['SMS', 'ChatStream', 'WhatsApp']);
export const FREQUENCY_OPTIONS = opt(['Once', 'Daily', 'Weekly', 'Monthly', 'Quarterly', 'Yearly']);

export const COND_OPERATORS = [
  'CONTAINS', 'DOES_NOT_CONTAIN', 'IS', 'IS_NOT', 'EQUAL', 'NOT_EQUAL',
  'GREATER_THAN', 'GREATER_THAN_OR_EQUAL', 'LESS_THAN', 'LESS_THAN_OR_EQUAL',
  'AFTER', 'BEFORE', 'ON', 'INCLUSIVE', 'EXCLUSIVE', 'HAS_VALUE',
];
export const PRODUCT_OPERATORS = ['INCLUSIVE', 'EXCLUSIVE'];

// Operator→word humanization now lives in segment/segmentHumanize.js (the shared
// summary humanizer). This module carries only the option/operator CONSTANTS used by
// the journey drawer selects and the segment condition builder.

export const NO_VALUE_OPERATORS = ['HAS_VALUE', 'HAS_NO_VALUE'];

const O = (value, label) => ({ value, label });

// Frontend-owned plain-label operator map, keyed by field type. Informed by the
// legacy DB junction (audience_segment_dimension_operator_type) intent + real beta
// usage. INCLUSIVE/EXCLUSIVE are the universal "is / is not (any of)" — real beta
// data uses them on both Text and Number. Follow-up: a /api/beta operators-per-type
// endpoint should own this so the frontend can fetch rather than hard-code.
const OPERATORS_BY_TYPE = {
  product: [O('INCLUSIVE', 'has'), O('EXCLUSIVE', "doesn't have"), O('HAS_VALUE', 'has any')],
  TEXT: [
    O('INCLUSIVE', 'is'), O('EXCLUSIVE', 'is not'),
    O('CONTAINS', 'contains'), O('DOES_NOT_CONTAIN', "doesn't contain"),
    O('HAS_VALUE', 'has any value'), O('HAS_NO_VALUE', 'has no value'),
  ],
  NUMBER: [
    O('INCLUSIVE', 'is'), O('EXCLUSIVE', 'is not'),
    O('GREATER_THAN_OR_EQUAL', 'at least'), O('GREATER_THAN', 'more than'),
    O('LESS_THAN_OR_EQUAL', 'at most'), O('LESS_THAN', 'less than'),
    O('HAS_VALUE', 'has any value'), O('HAS_NO_VALUE', 'has no value'),
  ],
  DATE_TIME: [
    O('AFTER', 'after'), O('BEFORE', 'before'), O('ON', 'on'),
    O('HAS_VALUE', 'has any value'), O('HAS_NO_VALUE', 'has no value'),
  ],
  BOOLEAN: [O('INCLUSIVE', 'is')],
};

export function operatorsForType(type) {
  return OPERATORS_BY_TYPE[type] || [];
}
